module.exports = __webpack_public_path__ + "static/media/2021_2A3A1051.642f9ba5.jpg";